var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookClosedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 13.125V1.875C17.5001 0.839453 16.6602 0 15.6251 0H3.75006C1.67897 0 6.10352e-05 1.67891 6.10352e-05 3.75V16.25C6.10352e-05 18.3211 1.67897 20 3.75006 20H16.2501C16.9403 20 17.5001 19.4402 17.5001 18.7852C17.5001 18.3273 17.242 17.9445 16.8751 17.7266V14.5484C17.2579 14.1719 17.5001 13.6797 17.5001 13.125ZM15.0001 17.5H3.75006C3.05983 17.5 2.50006 16.9402 2.50006 16.25C2.50006 15.5598 3.05983 15 3.75006 15H15.0001V17.5Z",
    fill: "#646471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookClosedIcon);
export default __webpack_public_path__ + "static/media/book-closed-icon.682b2f3593f04068cbcab434371ab425.svg";
export { ForwardRef as ReactComponent };